import { reportTypes } from '../../utils/reports';
import {
    getBaseConfig,
    getEmptyStateConfig,
    shelfDimensions,
    shelfMetadataDimensions,
    shelfTimeBreakdowns,
} from './baseReportConfig';
import { shelfPeriods } from './shelfPeriods';

const type = reportTypes.retention;
const path = '/react/retention';

const basicConfig = getBaseConfig(type, 'STATIC.PAGE_HEADERS.RETENTION', undefined, {
    disableSharedReports: true,
});

export default {
    ...basicConfig,
    header: {
        ...basicConfig.header,
        subText: {
            faqLink: 'https://support.singular.net/hc/en-us/articles/208156336-Retention-FAQ',
        },
        emptyStateHeaderData: getEmptyStateConfig('RETENTION'),
    },
    shelf: [shelfTimeBreakdowns, shelfDimensions, shelfMetadataDimensions, shelfPeriods],
    path,
    defaultDaysBack: 30,
    chart: {
        enabled: false,
        show: false,
    },
    disableCompare: true,
    hideDownloadReportButton: true,
    showDownloadReportDatesThreshold: Infinity,
};
